import { inject, Injectable } from '@angular/core';
import { combineLatest, Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

import { MijnLaunchDarklyService } from '@ap/mijn-kanaalconfiguratie';

import { ErrorContext } from '../../klant/login/error/error.model';
import { MijnLoginService } from '../mijn-login.service';

import { LoginState, LoginStatus } from './login-enabled.constants';

@Injectable({ providedIn: 'root' })
export class LoginEnabledService {
    private readonly mijnLoginService: MijnLoginService = inject(MijnLoginService);
    private readonly launchDarklyService: MijnLaunchDarklyService = inject(MijnLaunchDarklyService);
    private readonly loginDisabledObservable: Observable<[boolean, LoginStatus]>;

    constructor() {
        this.loginDisabledObservable = combineLatest([
            this.launchDarklyService.getFlagValue<boolean>('kill-switch-login', true),
            this.launchDarklyService.getFlagValue<LoginStatus>('config-login-status', { type: LoginState.DISRUPTION })
        ]).pipe(shareReplay(1));
    }

    public isEnabled(): Observable<boolean> {
        return this.loginDisabledObservable.pipe(
            map(([loginEnabled, loginStatus]) => {
                if (!loginEnabled) {
                    if (loginStatus?.type === LoginState.MAINTENANCE) {
                        this.mijnLoginService.setErrorContext(ErrorContext.DISABLED_MAINTENANCE);
                    } else {
                        this.mijnLoginService.setErrorContext(ErrorContext.DISABLED_DISRUPTION);
                    }
                }

                return loginEnabled;
            }),
            catchError(() => of(true))
        );
    }
}
